import { render, staticRenderFns } from "./organizationDetails.vue?vue&type=template&id=04f5599f&"
import script from "./organizationDetails.vue?vue&type=script&lang=js&"
export * from "./organizationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports